import { Pipe, PipeTransform } from '@angular/core';
import { AbnormalFlag } from '../types/sheet-action-aggregate-graph.types';

@Pipe({
	name: 'abnormalFlagLabel',
	standalone: true
})
export class AbnormalFlagLabelPipe implements PipeTransform {

	transform(flag: AbnormalFlag): string {
		switch (flag) {
			case AbnormalFlag.Normal:
				return 'Normal';
			case AbnormalFlag.BelowNormalRange:
				return 'Below Normal';
			case AbnormalFlag.AboveNormalRange:
				return 'Above Normal';
			case AbnormalFlag.BelowCriticalRange:
				return 'Below Critical';
			case AbnormalFlag.AboveCriticalRange:
				return 'Above Critical';
			case AbnormalFlag.BelowMeasurableRange:
				return 'Below Measurable';
			case AbnormalFlag.AboveMeasurableRange:
				return 'Above Measurable';
		}
	}
}
